//helpers
import { memo } from "react";
import isObjectEmpty from "../../helper/emptyObj";
const FacilityNavigate =memo(({distance,global,location}) => {
  let url = '';
  if (distance.current !== 0 && !isObjectEmpty(location)) {
    // open google maps with starting point the user coordinates
    url = `https://www.google.com/maps/dir/?api=1&origin=${location.lat},${location.lng}&destination=${distance.lat},${distance.lng}`;
  } else {
    // open google maps with selected destination coordinates
    url = `https://www.google.com/maps/dir/?api=1&destination=${distance.lat},${distance.lng}`;
  }
  return (
    <div className="location__link">
      {url ? (
        <a
          href={url}
          className="location__link-anchor"
          target="_blank"
          rel="noopener noreferrer"
        >
          {global.navigate}
        </a>
      ) : null}
      {distance.current !== 0 && !isObjectEmpty(location)
        ? `${distance.current} ${
            global.distanceText
          }`
        : null}
    </div>
  );
});

export default FacilityNavigate;
